import { useQuery } from '@tanstack/react-query'
import { getCompanyLocations } from 'api/company/location'
import { companyLocationsKey } from './keys'

export function useCompanyLocationsQuery(companyId: number | undefined) {
  return useQuery({
    queryKey: companyLocationsKey(companyId ?? 0),
    queryFn: () => {
      if (companyId === undefined) {
        throw new Error('companyId is required')
      }
      return getCompanyLocations(companyId)
    },
    enabled: companyId !== undefined,
  })
}
